<template>
    <v-app style="position: relative">
<!--        <SideBar style="z-index: 152" ref="sidebar"/>-->
<!--        <d-navbar style="z-index: 151; position:fixed; width: 100%; top: 0; background-color: #fff"/>-->
        <v-main style="margin-top: 68px;">
            <slot></slot>
        </v-main>
      <v-bottom-navigation height="72"  color="primary" app>
        <v-btn height="72" class="pb-4" x-large link to="/drugs">
          <span>Dorilar</span>

          <v-icon>mdi-list-box-outline</v-icon>
        </v-btn>
        <v-btn height="72" class="pb-4" x-large link to="/samples">
          <span>Shablonlar</span>

          <v-icon>mdi-file-document-check-outline</v-icon>
        </v-btn>

        <v-btn height="72" class="pb-4" x-large link to="/patients">
          <span>Bemorlar</span>
          <v-icon>mdi-account-multiple-outline</v-icon>
        </v-btn>

        <v-btn height="72" class="pb-4" x-large link @click="$router.push({name: 'profile'})">
          <span>Profile</span>
          <v-icon>mdi-cog</v-icon>
        </v-btn>
      </v-bottom-navigation>
    </v-app>

</template>

<script>

export default {
    name: "LayoutContent",
    components: {

    },
    data() {
        return {
            expanded: true
        }
    }
}
</script>

<style scoped>
.menu-icon {
    position: fixed;
    top: 20px;
    z-index: 153;
    cursor: pointer;
    transition: 0.2s;
}

.menu-icon:hover {
    opacity: 0.8;
}

.menu-icon:active {
    opacity: 0.6;
}


</style>
